// client/src/components/analytics/attributionFormat.js
//
// Shared formatting for the Growth Phase 1 attribution UI (PerformancePanel,
// LinkManager, scheduled-post history).

export const CONVERSION_KINDS = [
  'ticket_order', 'registration', 'raffle_entry', 'auction_bid', 'auction_win',
  'contest_entry', 'challenge_entry', 'checkin', 'form_submit', 'waitlist_join',
];

// Report sums mix orders, so show a plain amount in the browser's locale.
export function formatMoney(n) {
  return Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatCount(n) {
  return Number(n || 0).toLocaleString();
}

/** 0-100 width for a CSS bar, never NaN. */
export function barPct(value, max) {
  const v = Number(value) || 0;
  const m = Number(max) || 0;
  if (m <= 0 || v <= 0) return 0;
  return Math.max(2, Math.min(100, Math.round((v / m) * 100)));
}

/** Conversions per 100 clicks, one decimal; null when there were no clicks. */
export function conversionRate(conversions, clicks) {
  const c = Number(clicks) || 0;
  if (!c) return null;
  return Math.round(((Number(conversions) || 0) / c) * 1000) / 10;
}
